(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6146],{

/***/ 32266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings",
      function () {
        return __webpack_require__(91884);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _general_page__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81300);

/* harmony default export */ __webpack_exports__["default"] = (_general_page__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7165,5675,1664,6657,4321,4894,8972,1300,9774,2888,179], function() { return __webpack_exec__(32266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);